<template>
  <div class="item__form">
    <div class="price-calculator">
      <vs-input
        type="number"
        size="large"
        label="Count"
        v-model="count"
        @input="updatePriceFields($event, 'count')"
      ></vs-input>
      <span> x </span>
      <vs-input
        type="number"
        size="large"
        label="Price per unit"
        v-model="price_per_unit"
        @input="updatePriceFields($event, 'price_per_unit')"
      ></vs-input>
      <span> = </span>
      <vs-input
        type="number"
        size="large"
        label="Total cost"
        v-model="price"
        @input="updatePriceFields($event, 'price')"
      ></vs-input>
    </div>
    <div class="field">
      <vs-select
      label="Out reason"
      v-model="outcome_reason"
      >
      <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="item,index in outcomeReasonsList" />
    </vs-select>
    </div>
    <div class="field">
      <label for="">Out date</label>
      <v-date-picker
        v-model="purchased"
        mode="date"
        ref="calendar"
        label="Purchased"
      >
        <template v-slot="{ inputValue, inputEvents }">
          <div>
            <vs-input
              class="calendar-input"
              :value="`${inputValue}`"
              v-on="inputEvents"
              size="large"
            />
          </div>
        </template>
      </v-date-picker>
      <vs-textarea label="Description" v-model="desc" counter="500"/>
    </div>
    <div class="save-popup-button">
      <vs-button icon="save" @click="saveTransaction">Save</vs-button>
    </div>
  </div>
</template>

<script>
import OutcomeReasons from '@/components/common/dicts/outcomeReasons.js'

export default {
  name: 'TransactionForm',
  props: ['transaction', 'itemId'],
  data() {
    let data = {
      count: null,
      price_per_unit: null,
      price: null,
      purchased: new Date(),
      outcome_reason: 1,
      transaction_type: 2,
      outcomeReasonsList: OutcomeReasons,
      desc: null,
    }
    if (this.transaction && this.transaction.id) {
      data = { ...data, ...this.transaction }
      if (data.purchased) {
        data.purchased = new Date(data.purchased * 1000)
      }
      data.count = -data.count
      data.price = -data.price
      data.price_per_unit = -data.price_per_unit
    }

    return { ...data }
  },
  methods: {
    saveTransaction: function () {
      // TODO: avatar to base64
      let {
        count,
        price_per_unit,
        price,
        purchased,
        outcome_reason,
        transaction_type,
        desc
      } = this

      const data = {
        count,
        price_per_unit: parseFloat(price_per_unit),
        price: parseFloat(price),
        purchased: purchased ? purchased.getTime() / 1000 : new Date().getTime() / 1000,
        outcome_reason,
        transaction_type,
        desc: desc || "",
      }

      if (this.id) data.id = this.id
      this.$store
        .dispatch('items/saveTransactionsAction', {
          transaction: data,
          itemId: this.itemId
        })
        .then(() => {
          this.$emit('closePopup', this.closePopup)
        })
    },
    normalizeNumericValue(value) {
      if (value === '' || value === null || value === undefined) return null
      const parsedValue = parseFloat(value)
      return Number.isNaN(parsedValue) ? null : parsedValue
    },
    updatePriceFields(changedValue, changedField) {
      const count = this.normalizeNumericValue(this.count)
      const pricePerUnit = this.normalizeNumericValue(this.price_per_unit)
      // const price = this.normalizeNumericValue(this.price)

      if (changedField === 'count') {
        if (
          pricePerUnit !== null &&
          pricePerUnit !== undefined &&
          pricePerUnit !== 0
        ) {
          this.price = changedValue * pricePerUnit
        }
      }

      if (changedField === 'price_per_unit') {
        if (count !== null && count !== undefined && count !== 0) {
          this.price = count * changedValue
        }
      }

      if (changedField === 'price') {
        if (count !== undefined && count !== null && count !== 0) {
          this.price_per_unit = Number((changedValue / count).toFixed(2))
        } else if (
          pricePerUnit !== undefined &&
          pricePerUnit !== null &&
          pricePerUnit !== 0
        ) {
          this.count = Number((changedValue / pricePerUnit).toFixed(2))
        }
      }
    },

  },
}
</script>

<style lang="scss">

</style>
